import { EventEmitter, Directive, ElementRef, Output, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { fromEvent } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, filter } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class InputSearchDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
        this.debounceTimeDefault = 400;
        this.minStringLengthDefault = 0;
        // Set defaults
        this.debounceTime = this.debounceTimeDefault;
        this.stringLength = this.minStringLengthDefault;
        this.ngxInputSearch = new EventEmitter();
        this.stringTooShort = new EventEmitter();
        this.emptyInput = new EventEmitter();
        this.inputEl = this.el.nativeElement;
    }
    /**
     * Indicates how much time in ms we will wait for the users stops typing.
     * By default is 400ms
     * @param {?} dbTime
     * @return {?}
     */
    set debounceTime(dbTime) {
        this._debounceTime = dbTime ? dbTime : this.debounceTimeDefault;
    }
    /**
     * @return {?}
     */
    get debounceTime() {
        return this._debounceTime;
    }
    /**
     * Indicates the minimum length that must have the string to be emitted.
     * By default is 0
     * @param {?} stLength
     * @return {?}
     */
    set stringLength(stLength) {
        this._stringLength =
            stLength && stLength >= 0 ? stLength : this.minStringLengthDefault;
    }
    /**
     * @return {?}
     */
    get stringLength() {
        return this._stringLength;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // Subscribe to the input event
        this.inputEventSubs = fromEvent(this.inputEl, 'input')
            .pipe(
        // Wait until the user stops writing
        debounceTime(this.debounceTime), 
        // Transform the event to track the input value, to use it in the comparison
        map((/**
         * @param {?} event
         * @return {?}
         */
        event => ({
            value: ((/** @type {?} */ (event.target))).value.trim(),
            event,
        }))), 
        // Avoid emitting of the input value is the same
        distinctUntilChanged((/**
         * @param {?} prev
         * @param {?} next
         * @return {?}
         */
        (prev, next) => prev.value === next.value)), 
        // Validate the minimum length that must have the string
        filter((/**
         * @param {?} tmpObj
         * @return {?}
         */
        tmpObj => {
            if (tmpObj.value.length === 0) {
                // emit that the input is empty
                this.emptyInput.emit();
                return false;
            }
            if (tmpObj.value.length < this.stringLength) {
                // emit that the string length is too short
                this.stringTooShort.emit(tmpObj.value);
                return false;
            }
            else {
                return true;
            }
        })), 
        // Return only the input event
        map((/**
         * @param {?} tmpObj
         * @return {?}
         */
        tmpObj => tmpObj.event)))
            .subscribe((/**
         * @param {?} $event
         * @return {?}
         */
        $event => this.ngxInputSearch.next($event)));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.inputEventSubs.unsubscribe();
    }
}
InputSearchDirective.ɵfac = function InputSearchDirective_Factory(t) { return new (t || InputSearchDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
InputSearchDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: InputSearchDirective, selectors: [["", "ngxInputSearch", ""]], inputs: { debounceTime: "debounceTime", stringLength: "stringLength" }, outputs: { ngxInputSearch: "ngxInputSearch", stringTooShort: "stringTooShort", emptyInput: "emptyInput" } });
/** @nocollapse */
InputSearchDirective.ctorParameters = () => [
    { type: ElementRef }
];
InputSearchDirective.propDecorators = {
    ngxInputSearch: [{ type: Output }],
    debounceTime: [{ type: Input }],
    stringLength: [{ type: Input }],
    stringTooShort: [{ type: Output }],
    emptyInput: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputSearchDirective, [{
        type: Directive,
        args: [{
                selector: '[ngxInputSearch]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { debounceTime: [{
            type: Input
        }], stringLength: [{
            type: Input
        }], ngxInputSearch: [{
            type: Output
        }], stringTooShort: [{
            type: Output
        }], emptyInput: [{
            type: Output
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    InputSearchDirective.prototype.debounceTimeDefault;
    /**
     * @type {?}
     * @private
     */
    InputSearchDirective.prototype.minStringLengthDefault;
    /**
     * The output to indicate when the user finish to type on the
     * input search
     * @type {?}
     */
    InputSearchDirective.prototype.ngxInputSearch;
    /**
     * @type {?}
     * @private
     */
    InputSearchDirective.prototype._debounceTime;
    /**
     * @type {?}
     * @private
     */
    InputSearchDirective.prototype._stringLength;
    /**
     * Indicates when the string written length is shorter than the minimum
     * defined by the property `stringLength`
     * @type {?}
     */
    InputSearchDirective.prototype.stringTooShort;
    /**
     * Indicates when the input is empty
     * @type {?}
     */
    InputSearchDirective.prototype.emptyInput;
    /**
     * The native element instance of the input
     * @type {?}
     * @private
     */
    InputSearchDirective.prototype.inputEl;
    /**
     * The subscription to the input native event.
     * Useful to unsubscribe when is destroyed to avoid memory leaks
     * @type {?}
     * @private
     */
    InputSearchDirective.prototype.inputEventSubs;
    /**
     * @type {?}
     * @private
     */
    InputSearchDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxInputSearchModule {
}
NgxInputSearchModule.ɵfac = function NgxInputSearchModule_Factory(t) { return new (t || NgxInputSearchModule)(); };
NgxInputSearchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxInputSearchModule });
NgxInputSearchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxInputSearchModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [InputSearchDirective],
                exports: [InputSearchDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxInputSearchModule, { declarations: function () { return [InputSearchDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [InputSearchDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxInputSearchModule, InputSearchDirective as ɵa };

